import React, { useState, useEffect } from 'react'
import { connect } from 'dva'
import styles from './index.less'

const isPre = window.PROJECT_CONFIG.sentryMode === 'pre'

const AgentLoginAndPreBar = ({ currentUser }) => {
    const [inHeader, setInHeader] = useState(false)

    const { isAgent } = currentUser ?? {}

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const headerElement = document.getElementById('basicUiLayoutheader')

            if (headerElement) {
                // 监听鼠标移入事件
                headerElement.addEventListener('mouseover', () => {
                    setInHeader(true)
                })

                // 监听鼠标移出事件
                headerElement.addEventListener('mouseout', () => {
                    setInHeader(false)
                })

                // 停止观察，因为元素已经找到
                observer.disconnect()
            }
        })

        // 开始观察整个文档的变动，直到找到目标元素
        observer.observe(document.body, { childList: true, subtree: true })

        return () => {
            observer.disconnect() // 组件卸载时清除观察器
        }
    }, [])

    if (inHeader) {
        return null
    }

    return (
        <div className={styles.bar}>
            {isAgent ? <div className={styles.bar1}>正在使用代理登录身份使用客户数据，请不要执行修改操作。</div> : null}
            {isPre ? <div className={styles.bar2}>当前为预发环境，功能与正式有差异，请谨慎操作</div> : null}
        </div>
    )
}

export default connect(({ user }) => ({
    currentUser: user.currentUser
}))(AgentLoginAndPreBar)
